// enum which contains the survey states
const OrganisationUserRoles = Object.freeze({
  ORG_ADMIN: 'Admin',
  SURVEY_ADMIN: 'Survey Creator',
  DOCENT: 'Docent',
  TRANSLATOR: 'Translator'
});

export default OrganisationUserRoles;
